import React from 'react';
import { Card, Row, Col, Tag, Button } from 'antd';
import { CalendarOutlined, ClockCircleOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { mockBlogPosts, BlogPost } from '../models';
import { BlogNavbar } from '../components/website/BlogNavbar';
import './Blog.css';

const { Meta } = Card;

export function Blog() {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const BlogCard: React.FC<{ post: BlogPost }> = ({ post }) => (
    <Card
      hoverable
      className="blog-card"
      cover={
        post.featuredImage && (
          <div className="blog-card-cover">
            <img alt={post.title} src={post.featuredImage} />
          </div>
        )
      }
      actions={[
        <Link to={`/blog/${post.slug}`} key="read-more">
          <Button type="primary" size="large" block>
            Read More
          </Button>
        </Link>
      ]}
    >
      <Meta
        title={<h3 className="blog-card-title">{post.title}</h3>}
        description={
          <div className="blog-card-content">
            <p className="blog-excerpt">{post.excerpt}</p>
            <div className="blog-meta">
              <div className="meta-item">
                <UserOutlined /> {post.author}
              </div>
              <div className="meta-item">
                <CalendarOutlined /> {formatDate(post.publishedDate)}
              </div>
              <div className="meta-item">
                <ClockCircleOutlined /> {post.readTime} min read
              </div>
            </div>
            <div className="blog-tags">
              {post.tags.map(tag => (
                <Tag key={tag} color="blue">{tag}</Tag>
              ))}
            </div>
          </div>
        }
      />
    </Card>
  );

  return (
    <div className="blog-page">
      <BlogNavbar />
      <div className="container plr-page">
        <div className="blog-header">
          <h1>Our Blog</h1>
          <p className="blog-subtitle">
            Stay updated with the latest insights, tips, and news about website monitoring and status pages.
          </p>
        </div>
        
        <Row gutter={[32, 32]}>
          {mockBlogPosts.map(post => (
            <Col key={post.id} xs={24} md={12} lg={8}>
              <BlogCard post={post} />
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}